import { makeStyles } from "tss-react/mui";
import { GridToolbar, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import { Clear as ClearIcon, FilterListOff as FilterOffIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useDevice } from "../../../providers/DeviceProvider";


const useStyles = makeStyles()(
  (theme) => ({
    container: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(1),
      "& .MuiDataGrid-toolbarQuickFilter": {
        "& .MuiInputBase-root": {
          borderRadius: theme.spacing(1),
        },
        "& input": {
          paddingTop: "6px",
          paddingBottom: "6px"
        }
      },
      "@media (max-width: 500px)": {
        padding: 0,
        "& .MuiDataGrid-toolbarQuickFilter": {
          width: "120px",
          padding: 0,
          "& input": {
            padding: 0
          }
        },
        "& .MuiDataGrid-toolbarContainer": {
          rowGap: 0,
          columnGap: 0,
          width: "auto",
          "& button": {
            fontSize: 0,
            maxWidth: "32px !important",
            width: "32px",
            minWidth: "32px",
            marginLeft: "4px",
            marginRight: "4px",
            padding: "0 !important",
            overflow: "hidden",
            "& span": {
              margin: 0,
            }
          }
        }
      }
    },
    item: {
      display: "flex",
      alignItems: "baseline"
    }
  })
);

const CSV_OPTIONS = {
  delimiter: ";",
  utf8WithBom: true,
};


export default function EntityTableToolbar(props) {
  const { canSearch, onReset, isPinned, tableId } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { slim } = useDevice();

  return (

    <GridToolbarContainer className={classes.container}>
      {canSearch ? <GridToolbarQuickFilter size="small" variant="filled" hiddenLabel /> : <div></div>}
      <span className={classes.item}>
        <GridToolbar csvOptions={CSV_OPTIONS}  />
        {
          !!tableId && isPinned ? (
            slim ? (
              <IconButton size="small" onClick={onReset}>
                <FilterOffIcon fontSize="inherit" color="primary" />
              </IconButton>
            ) : (
              <Button startIcon={<ClearIcon fontSize="inherit" color="primary" />} size="small" onClick={onReset}>
                {t("common:resetTable")}
              </Button>
            )
          ) : null
        }
      </span>
    </GridToolbarContainer>

  );
}
